import { h, render, Component } from 'preact';
import CommonBlock from './../commonBlock';
import Utils from '../../../utils';
import { Context } from '../../context';
import CiblerAPI from '../../ciblerApi';
import './index.scss'

export default class Form extends CommonBlock {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      formData: [],
      userData: {},
      hidden: true,
      noImage: false,
    };
  }

  componentDidMount() {
    const content = this.renderContent();

    if (content) {
      this.setState({
        content,
      }, this.bindButtons);
    }

    setTimeout(() => this.setState({hidden: false}), 500);
    if (Utils.getCampaignData(this.props.customJS)) {
      try {
        eval(Utils.getCampaignData(this.props.customJS));
      } catch (e) {
        console.log('CustomJS error: ', {e});
      }
    }
  }

  getStyle = () => {
    let style = {};
    if (Utils.getCampaignData(this.props.textColor)) style.color = Utils.getCampaignData(this.props.textColor);
    const styleKey = ['backgroundColor', 'fontFamily', 'borderRadius'];
    styleKey.forEach((key) => {
      if (Utils.getCampaignData(this.props[key])) style[key] = Utils.getCampaignData(this.props[key]);
    });

    return style;
  };

  buttonStyle = () => {
    let style = {};
    if (Utils.getCampaignData(this.props.acceptButtonColor)) style.backgroundColor = Utils.getCampaignData(this.props.acceptButtonColor);
    if (Utils.getCampaignData(this.props.acceptButtonFontColor)) style.color = Utils.getCampaignData(this.props.acceptButtonFontColor);

    return style
  }

  handleSendData = (e) => {
    e.preventDefault();

    CiblerAPI.lightLogin(
      this.props.campaignId,
      this.state.userData,
      () => {
        CiblerAPI.discoverGift(Context[this.props.campaignId], this.completeGift(this.props.content?.value, true));
      });
    return false;
  }

  render() {
    const imageSrc = Utils.getCampaignData(this.props.backgroundImg)
      ? `${Context.clientUrl}campaigns/assets/${this.props.campaignId}/${Context.device}${Utils.getCampaignData(this.props.backgroundImg)}`
      : null;

    const modalStyle = {
      transition: 'opacity linear 500ms',
      display: this.state.hidden ? 'none' : '',
    };
    if (Utils.getCampaignData(this.props.modalColor, '')) modalStyle.backgroundColor = Utils.getCampaignData(this.props.modalColor, '');

    return (
      <div
        id="wio_form"
        style={this.state.hidden ? {bottom: '-100%', opacity: 0} : {}}
      >
        <div
          className="block"
          style={this.getStyle()}
        >
          {!this.state.noImage &&
            <img className="image" src={imageSrc}
                 onError={() => this.setState({noImage: true})}
            />
          }
          <div className="form">
            <div
              id="wioContent"
              dangerouslySetInnerHTML={{ __html: this.state.content }}
            />
            {!this.state.showGift &&
              <button
                id={"formButton_" + this.props.campaignId}
                className="discoverButton"
                dangerouslySetInnerHTML={{
                  __html: Utils.getCampaignData(this.props.acceptButtonText, "J'en profite")
                }}
                style={this.buttonStyle()}
                onClick={this.handleDiscover}
              />
            }
            <button
              id="wioBlockExit"
              style={this.getExitStyle()}
              onClick={this.closeBlock}
            >
              X
            </button>
          </div>
        </div>
        <div id="WioModal" className="WioModal" style={modalStyle} onClick={this.closeBlock} />
      </div>
    );
  }
}
